module.exports = __webpack_public_path__ + "static/media/banner.930fddd1.svg";